import React from 'react';

const selectionContext = React.createContext(null);

export default selectionContext;
